import api from "./api";

export interface MinhaInscricao {
  id: number;
  edital_id: number;
  edital_nome: string;
  status: "pendente" | "em_analise" | "aprovado" | "reprovado";
  created_at: string;
  updated_at: string;
  dados_formulario: Record<string, unknown>;
}

export interface InscricaoDetalhada extends MinhaInscricao {
  edital: {
    id: number;
    nome: string;
    status: string;
    vigente: boolean;
  };
  edital_detalhes: {
    descricao: string;
    data_inicio: string;
    data_fim: string;
    edital_pdf_url?: string;
    configuracoes: Record<string, unknown>;
    schema_campos: Record<string, any>;
  };
  observacoes?: string;
  analisado_em?: string;
  analisado_por?: {
    id: number;
    nome: string;
  };
  pode_editar: boolean;
  foi_analisada: boolean;
}

export interface CriarInscricaoParams {
  edital_id: number;
  dados_formulario: Record<string, unknown>;
}

const minhasInscricoesService = {
  // Listar minhas inscrições
  listar: async (): Promise<{ inscricoes: MinhaInscricao[] }> => {
    const response = await api.get("/api/v1/inscricoes/minhas");
    return response.data;
  },

  // Buscar inscrição
  buscar: async (id: number): Promise<{ inscricao: InscricaoDetalhada }> => {
    const response = await api.get(`/api/v1/inscricoes/${id}`);
    return response.data;
  },

  // Criar inscrição
  criar: async (
    params: CriarInscricaoParams
  ): Promise<{ inscricao: MinhaInscricao }> => {
    const response = await api.post("/api/v1/inscricoes", {
      inscricao: params,
    });
    return response.data;
  },

  // Atualizar inscrição
  atualizar: async (
    id: number,
    dados_formulario: Record<string, unknown>
  ): Promise<{ inscricao: MinhaInscricao }> => {
    const response = await api.put(`/api/v1/inscricoes/${id}`, {
      inscricao: { dados_formulario },
    });
    return response.data;
  },

  // Excluir inscrição
  excluir: async (id: number): Promise<{ message: string }> => {
    const response = await api.delete(`/api/v1/inscricoes/${id}`);
    return response.data;
  },
};

export default minhasInscricoesService;
